import Color from 'color';

import "./themes.css";

const THEMES = [ "dark", "light" ]

function ThemeProvider({ children, theme, applyBody, primary, secondary, success, warning, error }) {
    // if passed value is not in list, use default
    if (THEMES.indexOf(theme) < 0) theme = THEMES[0];
    // apply body.css
    if (applyBody) import('./body.css');
    // simply render the children :)
    return <div className={`yona-theme-${theme}${applyBody ? " applyBody" : ""}`} style={{
        display: "contents",
        "--yona-primary"  : primary   ? Color(primary)   : "var(--yona-teal)",
        "--yona-secondary": secondary ? Color(secondary) : "var(--yona-indigo)",
        "--yona-success"  : success   ? Color(success)   : "var(--yona-green)",
        "--yona-warning"  : warning   ? Color(warning)   : "var(--yona-orange)",
        "--yona-error"    : error     ? Color(error)     : "var(--yona-red)",
    }}>{children}</div>;
}

export default ThemeProvider;